export default "__VITE_ASSET__Di361cwu__"